let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bHEIh")).then(() => parcelRequire('aoP5b'));